// extracted by mini-css-extract-plugin
export default {"searchBox":"Search_searchBox__La7-6","searchImg":"Search_searchImg__8uwms","search":"Search_search__pVZHz","searchInput":"Search_searchInput__IYChz"};